import React from 'react';
import { Header } from '../Header';
import { Subtitle } from '../Subtitle';
import { OrganizerCardsContainer } from './OrganizerCardsContainer';
import { Organizer } from './utils';

export interface OrganizersSectionProps {
    header: string;
    subHeader: string;
    organizersList: Organizer[];
}

const OrganizersSection: React.FunctionComponent<OrganizersSectionProps> = ({
    header,
    subHeader,
    organizersList,
}) => {
    return (
        <div
            className="ttd-organizers-section"
            data-testid="ttd-organizer-section"
        >
            <div className="ttd-organizers-section__text">
                <Header title={header} />
                <Subtitle text={subHeader} />
            </div>
            <OrganizerCardsContainer organizersList={organizersList} />
        </div>
    );
};

export default OrganizersSection;
